export const PIPELINE_OBJECTS = {
  CONTACT: 'CONTACT',
  DEAL: 'DEAL',
  LEAD: 'LEAD',
  TICKET: 'TICKET'
};